import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectOrdersCreatedItem } from "../../../../redux/orders/selector";
import { cargoLeads } from "../../../../redux/cargo-lead/action";
import { currency, format, getBodyType } from "../../../../common/services/common.service";
import { selectAnnouncementsListItems } from "../../../../redux/announcements/selector";
import _ from "lodash";
import { announcements } from "../../../../redux/announcements/action";
import PageLoader from "../../../../components/PageLoader";

const AgentCargoOrderDetails = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const announcementsList = useSelector(selectAnnouncementsListItems)
    let fareAmount = _.find(announcementsList.result.items, ['Title', 'fareAmount']);

    const back = () => {
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
        navigate('/transport-agent/bookings/cargo')
    }

    const orderData = orderDetails?.result?.items?.Records[0]?.message?.order

    console.log(orderData, 'orderData')
    useEffect(
        () => {
            dispatch(announcements.list({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
                entity: 'announcements',
                jsonData: {}
            }))
        },
        []
    );
    return (
        <>
            {announcementsList?.isLoading ? <PageLoader /> :
                <div className="py-20 px-10 md:px-60">
                    {/* Back Button */}
                    <div className="text-right mb-6">
                        <button
                            onClick={back}
                            type="button"
                            className="text-primary font-medium px-4 py-2 rounded"
                        >
                            &larr; Back To Booking
                        </button>
                    </div>

                    {/* Heading */}
                    <div className="text-2xl font-bold text-center mb-8">
                        Thank you for Booking
                    </div>

                    {/* Booking Info */}
                    <div className="flex justify-between mb-6">
                        <div>
                            <div className="text-base font-medium">Booking ID: {orderData?.id}</div>
                            <div className="text-base font-medium">Tracking No: {orderData?.fulfillments[0]?.tracking_no}</div>
                        </div>
                        <div className="text-base font-medium text-right">
                            Schedule Date: {format(orderData?.items[0]?.time?.timestamp)}
                        </div>
                    </div>

                    <div className="border-b-2 border-gray-300 mb-10"></div>

                    {/* Details Section */}
                    <div className="flex text-center justify-between gap-10">
                        {/* Left Column */}
                        <div className="space-y-4 w-full md:w-1/2">
                            <div>
                                <div className="font-semibold">Vehicle Type</div>
                                <div>{getBodyType(orderData?.fulfillments[0]?.vehicle?.VehicleBodyTypeId)}</div>
                            </div>
                            <div>
                                <div className="font-semibold">Product Type</div>
                                <div>{orderData?.["@ondc/org/linked_order"]?.items?.[0]?.CategoryName}</div>
                            </div>
                            <div>
                                <div className="font-semibold">Payment Type</div>
                                <div>{orderData?.payment?.method}</div>
                            </div>
                            <div>
                                <div className="font-semibold">Amount</div>
                                <div>{currency(orderData?.quote?.price?.value)}</div>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 w-full md:w-1/2">
                            <div>
                                <div className="font-semibold">Total Distance</div>
                                <div>{orderData?.quote?.TotalDistance} Km</div>
                            </div>
                            <div>
                                <div className="font-semibold">Pickup Address</div>
                                <div className="text-sm">
                                    {orderData?.fulfillments[0]?.start?.location?.address?.locality},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.city} -{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.area_code},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.state},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.country}
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">Drop Address</div>
                                <div className="text-sm">
                                    {orderData?.fulfillments[0]?.end?.location?.address?.locality},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.city} -{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.area_code},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.state},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.country}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border-b border-gray-300 my-8"></div>

                    {/* Note */}
                    <div className="text-base">
                        <span className="font-semibold">Note:</span> {fareAmount?.Description}
                    </div>
                </div>
            }
        </>
    );
};

export default AgentCargoOrderDetails;


